






































































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';
import { AuthModule } from '@/store/Auth/AuthModule';
import CreateSecondaryWalletTypeRequest from '@/models/Products/ProductSettings/SecondaryWallets/General/CreateSecondaryWalletTypeRequest';
import FieldLabel from '@/components/Shared/FieldLabel.vue';
import PermissionUtils from '@/lib/permissionUtils';
import FeatureToggleCode from "@/models/Settings/Institutions/FeatureToggleCode";

@Component({ name: 'SecondaryWalletsCreateDialog', components: { FieldLabel } })
export default class extends SaascadaVueDialog {

    valid = false;
    dialog = false;
    secondaryWalletTypeRequest: CreateSecondaryWalletTypeRequest = new CreateSecondaryWalletTypeRequest();

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.secondaryWalletTypeRequest = new CreateSecondaryWalletTypeRequest();
        }
    }

    async save() {
        if (!this.valid) {
            return;
        }
        else {
            this.dialog = false;

            // If the CryptocurrencyOverride is enabled then override the crypto currencies
            // with a real currency so that they still work when sent to the platform
            if (PermissionUtils.isFeatureToggleEnabled(FeatureToggleCode.CryptocurrencyOverride)) {
                // Replace BTC with XPT
                this.secondaryWalletTypeRequest.generalSettings.allowedCurrencies = this.secondaryWalletTypeRequest.generalSettings.allowedCurrencies.map((currency) => { return currency === "BTC" ? "XPT" : currency; });
                // Replace ETH with XPD
                this.secondaryWalletTypeRequest.generalSettings.allowedCurrencies = this.secondaryWalletTypeRequest.generalSettings.allowedCurrencies.map((currency) => { return currency === "ETH" ? "XPD" : currency; });
            }

            await ProductDetailsModule.createSecondaryWallet(this.secondaryWalletTypeRequest);
        }
    }

    get availableCurrencies() {
        return AuthModule.me.institution.config.availableCurrencies;
    }

}
